(function ($) {
  $.fn.dropDown = function () {
    $(this).each(function () {

      if ($(this).data('rustig.dropdown.isloaded'))
        return;
      $(this).data('rustig.dropdown.isloaded', true);

      var dropdownAttr = 'dropdown-flyout';
      var selectDropdownIdAttr = 'dropdown-flyout-id';

      var reload = function () {
        populateOptions();
        selectItem($(null));
      };

      var reset = function () {
        $textInput.val('');
        $select.empty();
        $flyout.empty();
        if (!$select.data('no-empty-option')) {
          $select.append(emptyOption);
        }

        clearLastValue();
        reload();
      };

      var clearLastValue = function () {
        previouslySelectedValue = null;
      }

      var $select = $(this).bind('dropdown:reload', reload)
        .bind('dropdown:reset', reset)
        .bind('dropdown:clearLastValue', clearLastValue)
        .bind('dropdown:ondragstart', function (e) {
          close();
        });

      var dropDownId = '_id_' + Math.random();
      var selectId = $select.attr('id');
      var selectTextInput = selectId + '-input';
      $select.attr(selectDropdownIdAttr.asData(), dropDownId);

      var $textInput = $('<input type="text" autocomplete="off" autofill="false"></input>');
      $textInput.attr('data-filteritems', dropDownId)
        .attr('data-fi-selected-class', 'selected')
        .filteritems();

      //remove the dropdown button
      var hideButton = false;
      if ($select.attr("data-hidebutton") != null)
        hideButton = true;

      //when an item is selected display the option value rather than the option text
      var displayValue = false;
      if ($select.attr("data-displayvalue") != null)
        displayValue = true;

      //override flyout width (added by casepointe)
      var flyoutWidth = $select.outerWidth();
      var hasOverridenWidth = $select.attr("data-flyoutwidth") != null;
      if (hasOverridenWidth) {
        flyoutWidth = parseInt($select.attr("data-flyoutwidth"));
      }

      var $buttonHtml = $($select.data('button-html'));

      var $field = $('<div></div>').addClass('dropdown-field');

      let displayStyle = $select.css('display');
      if (displayStyle === "none") {
        $field.css('display', displayStyle);
      }

      $field.insertAfter($select);

      $(dropdownAttr.asDataSelector(dropDownId)).remove();

      var $flyout = $('<ul></ul>')
        .attr(dropdownAttr.asData(), dropDownId)
        .addClass('dropdown-flyout')
        .hide()
        .scroll(function () {
          $(document).unbind('click', documentClick);
          $(document).bind('click', documentClick);
        })
      $('body').append($flyout);

      var mouseInContainer = false;
      var mouseInField = false;
      var mouseInFlyout = false;

      var updateMouseInContainer = function () {
        mouseInContainer = mouseInField || mouseInFlyout;
      };

      $field.mouseenter(function () { mouseInField = true; updateMouseInContainer(); })
        .mouseleave(function () { mouseInField = false; updateMouseInContainer(); });
      $flyout.mouseenter(function () { mouseInFlyout = true; updateMouseInContainer(); })
        .mouseleave(function () { mouseInFlyout = false; updateMouseInContainer(); });

      $select.detach().appendTo($field);

      // Added by case pointe
      if ($field.parent().hasClass('dropdown-field')) {
        var parent = $field.parent();
        $field.detach().insertAfter(parent);
        parent.remove();
      }

      // Added by case pointe
      // Add relavent controls depending on what mode it's in.
      var allowsCustomInput = $select.is('[data-allow-custom-input]');
      if (allowsCustomInput) {
        var $input = $('<input type="hidden" />'); // Copy over all the attributes
        $input.attr('id', selectId);
        $input.attr('name', $select.attr('name'));
        $input.attr('class', $select.attr('class'));
        $input.addClass('real-input');

        // The hidden input is going to be the primary form value to post now.
        selectId = selectId + '-select';
        $select.attr('id', selectId);
        $select.removeAttr('name');

        $input.insertBefore($select);
        $input.val($select.attr('data-initial-input-value'));

        var selectedOption = $select.find('option[value="' + $input.val() + '"]');
        if (selectedOption && selectedOption.text()) {
          $textInput.data('initial-value', selectedOption.text());
        }
      }

      var doesSelectHaveValue = function (value) {
        if (!value || !value.length) {
          return false;
        }
        return $select.find('option[value="' + value + '"]').length > 0;
      };
      var $items = function () { return $('li', $flyout); };
      var $selected = function () { return $('li.selected', $flyout); };
      var changeSupressed = false;
      var previouslySelectedValue = $select.val();
      var setValue = function (value, text) {
        if (allowsCustomInput)
          setValueForCustomInput(value, text);
        else
          setValueForSelect(value);

        $textInput.filteritems('emptyFilter');
      };

      var setValueForCustomInput = function (value, text) {
        var selectHasValue = doesSelectHaveValue(value);
        var selectValue = selectHasValue ? value : null;
        setValueForSelect(selectValue);
        $input.val(text).change();
      };
      var setValueForSelect = function (value) {
        if (previouslySelectedValue == value) {
          $select.val(value);
          return;
        }
        previouslySelectedValue = value;

        changeSupressed = true;
        $select.val(value).change();
        changeSupressed = false;
      };

      var documentClick = function (e) {
        if ($(e.target).parents().index($field) == -1) {
          selectItem();
          close();
          $(document).unbind('click', documentClick);
        }
      };
      var toListItems = function (e) {
        var value = e.attr('value');
        var isEmpty = !value;

        var $item = $('<li>')
          .attr('data-fi', dropDownId)
          .attr('data-value', e.attr('value'))
          .attr('data-text', (e.text() || ''))
          .addClass('option');

        if (isEmpty)
          $item.attr('data-fi-empty', 'on')
            .addClass('dropdown-empty-option');

        if (e.text())
          $item.text(e.text());
        else
          $item.html('&nbsp');

        return $item[0].outerHTML;
      };
      var populateOptions = function () {
        var html = $select.children().map(function () { return toListItems($(this)); }).get().join('');
        $flyout.html(html);
      };
      populateOptions();

      $flyout.on('click', 'li', function () {
        $textInput.focus();
        selectItem($(this));
        close();
      });

      var displayItem = function ($item) {
        $items().removeClass('selected');
        $item.addClass('selected');
        if (displayValue) {
          $textInput.val($item.attr("data-value").trim());
          $textInput.attr('title', $item.text());
        } else {
          $textInput.val($item.text().trim());
        }
      };

      var textInputId = selectTextInput;

      if ($select.attr('readonly'))
        $textInput.attr('readonly', $select.attr('readonly'));
      if ($select.isDisabled())
        $textInput.disable();
      if ($select.attr('data-required'))
        $textInput.attr('data-required', $select.attr('data-required'));

      var onButtonClick = function (e) {
        if ($flyout.is(':visible'))
          close();
        else {
          open(e);
        }
        $textInput.focus();
        return false;
      }
      if ($select.attr("disabled") != undefined) {
        $textInput.attr("disabled", "disabled");
      }
      $textInput
        .addClass("dropdown-input input-field")
        .attr('id', textInputId)
        .val(function () {
          //use attr instead of data since data attempts to parse valus as int which loses precision. ("08" => 8) See: http://bugs.jquery.com/ticket/7579
          var initialValue = $select.attr('data-initial-input-value');
          if (allowsCustomInput) {
            return initialValue;
          }
          else {
            var foundItem = $select.find('option[value="' + initialValue + '"]');
            if (foundItem.length == 1) {
              if (displayValue) {
                $textInput.attr('title', foundItem.text());
                return foundItem.val();
              }
              return foundItem.text();
            }
            return null;
          }
        })
        .click(function (e) {
          onButtonClick(e);
        })
        .keydown(function (e) { keydown(e); })
        .keyup(function (e) { keyup(e); })
        .blur(function () {
          if (!mouseInContainer || tabKeyPressed) {
            selectItem();
            close();
            tabKeyPressed = false;
          }
        })
        .insertAfter($select);

      var initialTextValue = $textInput.data('initial-value');
      if (initialTextValue) {
        $textInput.val(initialTextValue);
      }

      if ($select.attr('placeholder'))
        $textInput.attr('placeholder', $select.attr('placeholder'));

      if ($select.attr('autofocus'))
        $textInput.attr('autofocus', 'autofocus');

      var $button = $(null);
      if (!hideButton) {
        $button = $('<button></button>')
          .attr('type', 'button')
          .attr('tabindex', '-1')
          .addClass('button button-icon dropdown-button')
          .click(onButtonClick)
          .append($buttonHtml)
          .insertAfter($textInput);
      }

      $select.hide();

      $select.change(function () {
        if (changeSupressed) return;
        resetValue();
      })
        .bind('disabled', function () {
          $textInput.disable();
          $button.disable();
        })
        .bind('enabled', function () {
          $textInput.enable();
          $button.enable();
        })
        .focus(function () {
          $textInput.focus();
        });

      var open = function (e) {
        if ($flyout.is(':visible') || $textInput.isReadonly() || $textInput.isDisabled())
          return false;

        var $containerFlyout = $(e.target).closest('[class $= "-flyout"]');
        $('[class $= "-flyout"]').not($containerFlyout).hide();
        $items().show().removeHighlight();
        var width = hasOverridenWidth ? flyoutWidth : $textInput.outerWidth();

        $flyout.css('width', width);
        Rustig.ElementPosition.setPositionByElement($flyout, $textInput);
        $flyout.show();
      };
      var close = function () {
        $flyout.hide();
      };
      var tabKeyPressed = false;
      var enterPressed = false;
      var keydown = function (e) {
        var key = e.keyCode;
        tabKeyPressed = key == 9;
        enterPressed = key == 13;
        var upPressed = key == 38;
        var downPressed = key == 40;

        if (tabKeyPressed) {
          return;
        } else if (enterPressed) {
          selectItem();
          close();
        } else if (upPressed) {
          open(e);
          var $prev = $selected().prev('li');
          while ($prev.length > 0 && $prev.is('[data-fi-filtered]'))
            $prev = $prev.prev('li');
          if ($selected().length > 0 && $prev.length > 0) {
            $selected().removeClass('selected');
            $prev.addClass('selected');
            $flyout.scrollTo($prev);
          }
        } else if (downPressed) {
          open(e);
          var $next = $selected().next('li');
          while ($next.length > 0 && $next.is('[data-fi-filtered'))
            $next = $next.next('li');
          if ($selected().length == 0) {
            var $listItems = $items();
            var $firstItem = $listItems.filter(':visible').first();
            $firstItem.addClass('selected');
            $flyout.scrollTo($firstItem);
          }
          else if ($next.length > 0) {
            $selected().removeClass('selected');
            $next.addClass('selected');
            $flyout.scrollTo($next);
          }
        }
      };
      var emptyOption = '<option></option>';

      var keyup = function (e) {
        var key = e.keyCode;
        if (key == 9 || key == 13 || key == 16 || key == 38 || key == 40)
          return;

        if (key == 27) { //esc 
          resetValue();
          close();
          return;
        }

        open(e);

        $textInput.filteritems('filterItems');
      };

      $select[0].displayItem = function ($item) { displayItem($item); }; //CAN WE KILL!

      var selectItem = function ($item) {
        $item = $item || $selected();

        var hasSelectedItem = $item.length != 0;
        if (!hasSelectedItem && !allowsCustomInput)
          $item = $items().filter('[data-value="' + $select.val() + '"]');

        hasSelectedItem = $item.length != 0;
        if (hasSelectedItem)
          displayItem($item);

        var value = !allowsCustomInput || hasSelectedItem ? $item.attr('data-value') : '';

        setValue(value, $textInput.val());
      };
      var resetValue = function () {
        var $item = $items().filter('[data-value="' + $select.val() + '"]');
        selectItem($item);
      };
      var escapeRegExp = function (str) {
        return str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
      };
    });

    var cleanUpOrphanedFlyouts = function () {
      $('[data-dropdown-flyout]').each(function () {
        var id = $(this).data('dropdown-flyout');
        var shouldDelete = $('dropdown-flyout-id'.asDataSelector(id)).length == 0;

        if (shouldDelete)
          $(this).remove();
      });
    }();
  };

  $(document).on('dragstart.rustig.modal', function (e) {
    $(e.target).find('.dropdown-field select').trigger('dropdown:ondragstart');
  });

})(jQuery);
